import React, { useEffect } from 'react';
import styled from 'styled-components';

import dingSoundSrc from 'assets/windows_xp_sounds/Windows XP Ding.wav';
import notifySoundSrc from 'assets/windows_xp_sounds/Windows XP Notify.wav';
import infoIcon from 'assets/windowsIcons/747(32x32).png';

function InfoBox({ onClose, message = 'Done!', buttons }) {
  useEffect(() => {
    const sound = new Audio(dingSoundSrc);
    sound.play().catch(() => {
      // fallback to notify
      new Audio(notifySoundSrc).play().catch(() => {});
    });
  }, []);

  const buttonList = buttons || [{ label: 'OK', action: 'ok' }];

  return (
    <Div>
      <div className="info__top">
        <img src={infoIcon} alt="info" className="info__img" />
        <div className="info__messages">
          <p className="info__message">{message}</p>
        </div>
      </div>
      <div className="info__bottom">
        {buttonList.map((btn, i) => (
          <div
            key={i}
            onClick={() => {
              if (btn.onClick) btn.onClick();
              onClose();
            }}
            className="info__button"
          >
            <span className="info__confirm">{btn.label}</span>
          </div>
        ))}
      </div>
    </Div>
  );
}

const Div = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
  font-size: 11px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  .info__top {
    display: flex;
    flex: 1;
  }
  .info__img {
    width: 30px;
    height: 30px;
  }
  .info__messages {
    padding: 2px 20px 12px;
  }
  .info__message {
    line-height: 16px;
  }
  .info__bottom {
    display: flex;
    width: 100%;
    justify-content: center;
    gap: 8px;
  }
  .info__button {
    min-width: 80px;
    height: 22px;
    display: flex;
    border: 1px solid black;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    box-shadow: inset -1px -1px 1px black;
    cursor: pointer;
    &:hover:active {
      box-shadow: inset 1px 1px 1px black;
      & > * {
        transform: translate(1px, 1px);
      }
    }
  }
  .info__confirm {
    line-height: 11px;
    white-space: nowrap;
  }
`;

export default InfoBox;
